document.addEventListener('click', async function (event) {
  const button = event.target.closest('[data-cart-upsell-add]');
  if (!button) return;

  event.preventDefault();

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  button.disabled = true;
  button.textContent = '...';

  const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

  const formData = {
    items: [
      {
        id: Number(variantId),
        quantity: 1
      }
    ]
  };

  if (cart && typeof cart.getSectionsToRender === 'function') {
    formData.sections = cart.getSectionsToRender().map((section) => section.id);
    formData.sections_url = window.location.pathname;
  }

  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    const parsedState = await response.json();

    if (cart && typeof cart.renderContents === 'function' && parsedState.sections) {
      cart.renderContents(parsedState);
    } else {
      window.location.reload();
    }
  } catch (error) {
    button.disabled = false;
    button.textContent = 'Hinzufügen';
  }
});